<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      app
      permanent
      expand-on-hover
      mini
      width="350"
    >
      <v-list nav dense>
        <v-list-item link to="/">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="text-uppercase">Accueil</v-list-item-title>
        </v-list-item>

        <v-list-group prepend-icon="mdi-account-group" no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="text-uppercase"
                >Gestion des Pédagogique</v-list-item-title
              >
            </v-list-item-content>
          </template>
          <v-list-item link :to="{ name: 'students' }">
            <v-list-item-icon>
              <v-icon>mdi-menu-right</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-uppercase"
              >Gestions des étudiants</v-list-item-title
            >
          </v-list-item>
          <v-list-item link :to="{ name: 'lessons' }">
            <v-list-item-icon>
              <v-icon>mdi-menu-right</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-uppercase"
              >Gestion des cours</v-list-item-title
            >
          </v-list-item>
          <v-list-item link :to="{ name: 'lecturers' }">
            <v-list-item-icon>
              <v-icon>mdi-menu-right</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-uppercase"
              >Gestion des intervenants</v-list-item-title
            >
          </v-list-item>
          <v-list-item link :to="{ name: 'programmes' }">
            <v-list-item-icon>
              <v-icon>mdi-menu-right</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-uppercase"
              >Gestion du programme</v-list-item-title
            >
          </v-list-item>
        </v-list-group>

        <v-list-group prepend-icon="mdi-finance" no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="text-uppercase"
                >Gestion Financiére</v-list-item-title
              >
            </v-list-item-content>
          </template>
          <v-list-item link to="/">
            <v-list-item-icon>
              <v-icon>mdi-menu-right</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-uppercase"
              >Gestions des paiements</v-list-item-title
            >
          </v-list-item>
          <v-list-item link to="/">
            <v-list-item-icon>
              <v-icon>mdi-menu-right</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-uppercase"
              >Relance</v-list-item-title
            >
          </v-list-item>
        </v-list-group>
       
        <v-list-item link to="/admin">
          <v-list-item-icon>
            <v-icon>mdi-cog</v-icon>
          </v-list-item-icon>
          <v-list-item-title to="/admin" class="text-uppercase"
            >Admin</v-list-item-title
          >
        </v-list-item>

        <v-list-item link to="/">
          <v-list-item-icon>
            <v-icon>mdi-file-search-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="text-uppercase">Requête</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      app
      color="blue"
      dark
    >
    <v-toolbar-title>
      <img src="@/assets/logo.png" height="72px" />
    </v-toolbar-title>    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  components: {
  },

  data: () => ({
    drawer: null,
    }),
};
</script>
